export { default as ImageToolbar } from '@ckeditor/ckeditor5-image/src/imagetoolbar'
